import React from 'react'

/**
 * Uses a higher-order state from context if available
 *
 * @param context the context value
 * @param name name of the variable in context, following react convention <param>, set<param>
 * @param defaultValue default value to give the state, if local is used
 * @returns [state, setState] the final state value/setter function
 */
const useOptionalContextState = (context: any, name: string, defaultValue: any): [any, (arg: any) => any] => {
    const [localState, setLocalState] = React.useState(defaultValue)
    const [state, setState] = [
        context[name] ?? localState,
        context['set' + name.substring(0, 1).toUpperCase() + name.substring(1) ?? setLocalState],
    ]
    return [state, setState]
}

export default useOptionalContextState
